module.exports = __webpack_public_path__ + "img/140.5564585d.jpg";